module.exports = __webpack_public_path__ + "img/Zunge.75b12aaa.jpg";